import type userProfileUseCases from '../../domain/useCases'
import { AlertWindow, Button } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useUserProfileStore } from '../../infrastructure/useUserProfileStore'

interface DeleteAccountProps {
  useCases: ReturnType<typeof userProfileUseCases>
}

export function DeleteAccount({ useCases }: DeleteAccountProps) {
  const intl = useIntl()
  const isDeleteAlertOpen = useUserProfileStore(state => state.isDeleteAlertOpen)
  const setIn = useUserProfileStore(state => state.setIn)

  const handleCloseAlert = () => {
    setIn('isDeleteAlertOpen', false)
  }

  const handleConfirmDelete = async () => {
    await useCases.deleteAccount()
  }

  return (
    <AlertWindow.Root open={isDeleteAlertOpen} onOpenChange={setIn.bind(null, 'isDeleteAlertOpen')}>
      <AlertWindow.Trigger>
        <Button $type="transparentPrimary" $size="XS">
          {intl.formatMessage({ id: 'user_profile_delete' })}
        </Button>
      </AlertWindow.Trigger>
      <AlertWindow.Content
        hasIcon
        text={intl.formatMessage({ id: 'user_profile_delete_confirmation_title' })}
        supportingText={intl.formatMessage({ id: 'user_profile_delete_confirmation_description' })}
        primaryButtonText={intl.formatMessage({ id: 'user_profile_delete_confirm' })}
        secondaryButtonText={intl.formatMessage({ id: 'user_profile_delete_cancel' })}
        onPrimaryAction={handleConfirmDelete}
        onSecondaryAction={handleCloseAlert}
      />
    </AlertWindow.Root>
  )
}
